import userReducer from './userReducer';
import authReducer from './authReducer';
import libsReducers from './libsReducers';

import { combineReducers } from 'redux';

//Combine all the sub reducers
const rootReducer = combineReducers({
      user: userReducer,
      auth: authReducer,
      libs: libsReducers
})

export default rootReducer